import { useAuth0 } from '@auth0/auth0-react';
import axios from 'axios';
import { useEffect, useState } from 'react';
import { AuthContext } from '../Contexts/AuthContext';
import CONFIG from '../Services/CONFIG';

const Http = {
  get: async (address, headers) => {
    const res = await fetch(address, { headers });
    if (!res.ok) throw new Error(res.status);
    return res.json();
  },
};

export const Auth0AppProvider = ({ children }) => {
  const {
    user,
    isAuthenticated,
    getAccessTokenSilently,
    logout,
    isLoading,
    error,
    loginWithRedirect,
  } = useAuth0();
  const [status, setStatus] = useState({ status: 'connecting' });

  // API health check (using the server from CONFIG)
  useEffect(() => {
    async function checkApiStatus() {
      if (!isAuthenticated) return; // Skip API call if not authenticated
      try {
        const token = await getAccessTokenSilently();
        const headers = { Authorization: `Bearer ${token}` };
        const response = await Http.get(`${CONFIG.SERVER_ORGANIZATION}/health/connect`, headers);
        // console.log('API Status: ', response);
        setStatus({ ...response, address: CONFIG.SERVER });
      } catch (error) {
        console.error('API health check error:', error);
        logout({ returnTo: window.location.origin });
      }
    }
    checkApiStatus();
  }, [isAuthenticated, getAccessTokenSilently, logout, user?.permissions]);

  // Axios interceptor
  useEffect(() => {
    const interceptor = axios.interceptors.response.use(
      (res) => res,
      (error) => {
        if (error.response?.status === 401) {
          logout({ returnTo: window.location.origin });
        }
        return Promise.reject(error);
      },
    );
    return () => axios.interceptors.response.eject(interceptor);
  }, [logout]);

  const login = async (opts = {}) => {
    const redirectTo = opts.redirectTo || window.location.href;

    await loginWithRedirect({
      appState: { returnTo: redirectTo },
    });
  };

  return (
    <AuthContext.Provider
      value={{
        provider: 'auth0',
        initialized: !isLoading,
        user,
        isAuthenticated,
        getAccessTokenSilently,
        login,
        logout,
        status,
        error,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
